import React, { useState } from "react"
import { makeStyles } from "@material-ui/core"
// @ts-ignore
import { useParams } from "react-router-dom"
import { Input } from "./input"
import { Select } from "./select"
import store from "src/store"
import { requestJSON } from "src/utils/request-module"
import CustomModal from "./custom-modal"
import InputText from "./input-text"
import { DialogContentText } from "@material-ui/core"
import { CopyIcon, EditIcon } from "./icons-svg"
import copyToClipboard from "copy-to-clipboard"
import Tooltip from "./tooltip"

const useStyles = makeStyles({
  icon: {
    display: "inline-block",
    fontSize: "18px",
    color: "#2E2E38",
    marginLeft: "10px",
  },
  clickable: {
    cursor: "pointer",
  },
})

var parameterStyle = {
  padding: "10px 5px",
}
/**
 * @param props {object}
 * @param props.value {any}
 * @param props.onChange {any}
 * @param props.label {string}
 */
export default function BytesInput(props) {
  const { id } = useParams()
  const classes = useStyles()

  /** It's include dynamic */
  store.useRerenderIfChange(() => [store.getSelectedSimulationByte32ListObj()])

  const defaultCopyTip = "Copy to clipboard"
  const [copyTip, setCopyTip] = useState(defaultCopyTip)
  const [showSelectList, setShowSelectList] = useState(true)
  const [showByte32NameModal, setShowByte32NameModal] = useState(false)
  const [newByte32, setNewByte32] = useState(null)
  const [byte32Name, setByte32Name] = useState("")
  const [byte32HasName, setByte32HasName] = useState(false)
  const [byte32NameHasError, setByte32NameHasError] = useState(false)
  const [byte32NameErrorText, setByte32NameErrorText] = useState("")

  var Style = { ...parameterStyle, width: 440 }

  let value = props.value && String(props.value);
  value = value?.replace(/[^A-Fa-f0-9x]/g, "")
  value = value?.slice(0, 66)

  if (value && !value.match(/^0x[0-9a-fA-F]{64}$/)) {
    Style = {
      ...Style,
      // @ts-ignore
      borderColor: "red",
    }
  }

  const onSubmitByte32 = (hash) => {
    // eslint-disable-next-line no-prototype-builtins
    if (store.getSelectedSimulationByte32ListObj().hasOwnProperty(hash)) {
      setByte32HasName(true)
      setByte32Name(store.getSelectedSimulationByte32ListObj()[hash])
    } else {
      setByte32HasName(false)
      setByte32Name("")
    }
    setNewByte32(hash)
    setShowByte32NameModal(true)
  }

  const onModalClose = () => {
    setByte32Name("")
    setByte32HasName(false)
    setByte32NameHasError(false)
    setByte32NameErrorText("")
    setShowByte32NameModal(false)
    setShowSelectList(true)
  }

  const updateByte32List = async () => {
    store.selectedSimulationByte32List[newByte32] = byte32Name
    store.updateStore()
    try {
      await requestJSON("PUT", "/simulation/" + id, {
        byte32List: store.selectedSimulationByte32List,
      })
    } catch (err) {
      console.log("Some error has occured while updating byte32 list ", err)
    } finally {
      onModalClose()
    }
  }

  const copy = () => {
    copyToClipboard(value)
    setCopyTip("Copied!")
    setTimeout(() => {
      try {
        // in timeout might be an error of updating unmounted component
        setCopyTip(defaultCopyTip)
      } catch (err) {
        const noop = function () {}
        noop() // eslint don't allow empty blocks
      }
    }, 2000)
  }

  return (
    <div style={{ whiteSpace: "nowrap" }}>
      <CustomModal
        size="medium"
        title="Add name"
        showModal={showByte32NameModal}
        onCloseModal={() => {
          onModalClose()
        }}
        submitBtnText={byte32Name ? "Update" : "Delete"}
        onSubmit={(e) => {
          e.preventDefault()
          updateByte32List()
        }}
        submitBtnDisabled={false}
      >
        <>
          <DialogContentText color="textPrimary">
            {byte32HasName
              ? "The byte32 " +
                store.shortenedByte32(newByte32) +
                " already have a name. Please update if you want to change."
              : "The byte32 " +
                store.shortenedByte32(newByte32) +
                " does not have a name yet. Please enter a name."}
          </DialogContentText>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              updateByte32List()
            }}
          >
            <div css="margin-top: 15px;">
              <InputText
                id={"byte32Name"}
                label={"Name"}
                value={byte32Name}
                disabled={false}
                onChange={(value) => {
                  setByte32Name(value)
                }}
                hasError={byte32NameHasError}
                errorText={byte32NameErrorText}
              />
            </div>
          </form>
        </>
      </CustomModal>
      <div
        css={`
          width: 100%;
          display: inline-block;
        `}
      >
        {showSelectList ? (
          <>
            <div
              css="
              display: flex;   
              align-items: center;"
            >
              <div css="flex-grow: 1;">
                <Select
                  label={props.label}
                  // @ts-ignore
                  labelBackground={props.labelBackground}
                  value={value || ""}
                  size="small"
                  disabled={
                    // eslint-disable-next-line no-prototype-builtins
                    props.hasOwnProperty("disabled") && props["disabled"]
                  }
                  onChange={(e) => {
                    if (e.target.value == "showManualByte32") {
                      setShowSelectList(false)
                    } else {
                      props.onChange(e)
                    }
                  }}
                >
                  {store.getSelectedSimulationByte32ListArr().map((item) => (
                    <option key={item.hash} value={item.hash}>
                      {item.name
                        ? item.name +
                          "(" +
                          store.shortenedByte32(item.hash) +
                          ")"
                        : item.hash}
                    </option>
                  ))}
                  <option value={"showManualByte32"}>Type manual byte32</option>
                </Select>
              </div>
              {!props["disabled"] && (
                <>
                  <div>
                    <span
                      className={`${classes.icon} ${classes.clickable}`}
                      onClick={() => {
                        setShowSelectList(false)
                      }}
                    >
                      {EditIcon(14)}
                    </span>
                  </div>
                </>
              )}
              <div>
                <Tooltip tip={copyTip}>
                  <span
                    css={`
                      visibility: ${value ? "visible" : "hidden"};
                    `}
                    className={`${classes.icon} ${classes.clickable}`}
                    onClick={() => {
                      copy()
                    }}
                  >
                    {CopyIcon(14)}
                  </span>
                </Tooltip>
              </div>
            </div>
          </>
        ) : (
          <>
            <Input
              {...props}
              isValidFunc={(x) => x?.match(/^0x[0-9a-fA-F]{64}$/)}
              value={value || ""}
              maxLength={66}
              placeholder="0x..."
              label={props.label}
              // @ts-ignore
              labelBackground={props.labelBackground}
              onBlur={(e) => {
                props.onChange(e)
                setTimeout(() => {
                  setShowSelectList(true)
                }, 200)
              }}
              onAddBtnClick={() => {
                if (value && value.match(/^0x[0-9a-fA-F]{64}$/)) {
                  onSubmitByte32(value || '')
                } else {
                  console.log("Byte32 is invalid. Cannot add name.")
                }
              }}
              onClear={() => {
                setShowSelectList(true)
              }}
            />
          </>
        )}
      </div>
      {/* <div css={`
      vertical-align:middle;
      padding-left:5px;
      display:inline-block;
      `}>
        <ShowContractName address={value || ""} />
      </div> */}
    </div>
  )
}
